<template>
  <div class="Clan-flag">
    <img
      :src="tag ? '/assets/icons/clan.png' : '/assets/icons/noclan.png'"

      :class="tag ? 'Clan--found' : 'Clan--unknown'"

      :style="'width:  ' + size + 'px;' +
              'height: ' + size + 'px;'"
    />
  </div>
</template>

<script>
  export default {
    props: {
      size: {
        default: 40
      },

      tag: {
        default: null
      }
    }
  };
</script>

<style lang="scss" scoped>
  .Clan-flag {
    display: inline-block;

    &--found {
      opacity: 1;
    }

    &--unknown {
      opacity: .8;
    }
  }
</style>